import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";
import { quotation } from "../comparator/fragments";

export const QUOTATION_INITIALIZED = gql`
  subscription quotationInitialized($documentId: Int!) {
    quotationInitialized(documentId: $documentId) {
      quotation {
        documentId
        offerId
        insurerId
        insurerName
        period
        insurerMessages
        additionalInfo
        runningYN
        userName
        offerDate
        currencyCode
        details {
          offerDetailId
          insuranceAmount
          isDirectCompensation
          selected
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const QUOTATION_COMPUTED = gql`
  subscription quotationComputed($documentId: Int!) {
    quotationComputed(documentId: $documentId) {
      quotation {
        ...quotation
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${quotation}
  ${messageHeaders}
`;

export const QUOTATIONS_INITIALIZED = gql`
  subscription quotationsInitialized($documentId: Int, $renewalDocumentId: Int) {
    quotationsInitialized(documentId: $documentId, renewalDocumentId: $renewalDocumentId) {
      quotationData {
        documentId
        quotationsDate
        quotations {
          ...quotation
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${quotation}
  ${messageHeaders}
`;

export const INSURANCE_OFFER_DETAIL_UPDATED = gql`
  subscription insuranceOfferDetailUpdated($offerDetailId: Int!) {
    insuranceOfferDetailUpdated(offerDetailId: $offerDetailId) {
      offerDetailId
      insuranceAmount
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const RCA_QUOTATION_DATA_CHANGED = gql`
  subscription rcaQuotationDataChanged($documentId: Int!) {
    rcaQuotationDataChanged(documentId: $documentId) {
      quotationData {
        documentId
        quotations {
          ...quotation
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${quotation}
  ${messageHeaders}
`;

export const DOCUMENT_OFFER_DETAIL_CHANGED = gql`
  subscription documentOfferDetailChanged($documentId: Int!) {
    documentOfferDetailChanged(documentId: $documentId) {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const INSURANCE_OFFERS_INVALIDATED = gql`
  subscription insuranceOffersInvalidated($documentId: Int!) {
    insuranceOffersInvalidated(documentId: $documentId) {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
